import { ROUTES_ADMIN } from '@/constants/routes';

export default {
    path: '/admin',
    name: ROUTES_ADMIN.ADMIN,
    redirect: '/admin/dashboard',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/*webpackChunkName: 'admin'*/ '@/views/admin/AdminLayout.vue'),
    meta: {
        requiresAuth: true,
        requiresAdmin: true
    },
    children: [
        {
            path: '/admin/dashboard',
            name: ROUTES_ADMIN.DASHBOARD,
            component: () => import(/*webpackChunkName: 'admin'*/ '@/components/admin/dashboard/DashboardContent')
        },
        {
            path: '/admin/users',
            name: ROUTES_ADMIN.USERS,
            component: () => import(/*webpackChunkName: 'admin'*/ '@/components/admin/users/Users')
        },
        {
            path: '/admin/user/:id?',
            name: ROUTES_ADMIN.USER_FORM,
            component: () => import(/*webpackChunkName: 'admin'*/ '@/components/admin/user/UserForm.vue')
        },
        {
            path: '/admin/clubs',
            name: ROUTES_ADMIN.CLUBS,
            component: () => import(/*webpackChunkName: 'admin'*/ '@/components/admin/clubs/Clubs')
        },
        {
            path: '/admin/edit-club/:id',
            name: ROUTES_ADMIN.EDIT_CLUB,
            component: () => import(/*webpackChunkName: 'admin'*/ '@/components/admin/club/EditClub.vue')
        },
        {
            path: '/admin/create-club/:userId?',
            name: ROUTES_ADMIN.CREATE_CLUB,
            component: () => import(/*webpackChunkName: 'admin'*/ '@/components/admin/club/CreateClub.vue')
        }
    ]
};
